import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StoreAvailableAdjustmentRequestAction } from './store-available-adjustment-request.actions';
import { StoreAvailableAdjustmentRequestService } from '../../service/store-available-adjustment-request.service';

@Injectable()
export class StoreAvailableAdjustmentRequestEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: StoreAvailableAdjustmentRequestService
  ) {}

  loadStoreAvailableAdjustmentRequestListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StoreAvailableAdjustmentRequestAction.requestList),
      tap((action) =>
        this.logger.debug(
          '@Effect Store Available Adjustment Request List Requested: ' + JSON.stringify(action.criteriaObj)
        )
      ),
      switchMap((action) => {
        return this.service.getStoreAvailableAdjustmentRequestList(action.criteriaObj).pipe(
          map((data: any) => StoreAvailableAdjustmentRequestAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
